import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import FeatherIcon from "feather-icons-react";
import Button from "./button";
import { createCustomer } from "../core/axios/endpoints"; // Importing the createCustomer function
import { toastrError, toastrSuccess } from "../utils/alertify";

const CreateUserModal = ({ isOpen, onClose }) => {
  const [validationSchema, setValidationSchema] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const modal = document.getElementById("create-user-modal");
    if (isOpen) {
      modal.showModal();
    } else if (modal.open) {
      modal.close();
    }
  }, [isOpen]);

  const handleClose = () => {
    onClose();
  };

  const handleESC = (event) => {
    event.preventDefault();
    handleClose();
  }

  const schema = () => {
    return Yup.object().shape({
      naam: Yup.string().required("Naam is verplicht"),
      telefoonNummer: Yup.string().required("Telefoon Nummer is verplicht"),
      email: Yup.string().required("Email is verplicht").email("Email is invalid"),
    });
  };

  useEffect(() => {
    setValidationSchema(schema());
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const submitForm = async (data) => {
    setIsLoading(true);
    try {
      const response = await createCustomer({
        naam: data.naam,
        email: data.email,
        telefoonnummer: data.telefoonNummer,
      });
      toastrSuccess( response?.message  || "User created successfully");
      setIsLoading(false);
      handleClose();
    } catch (error) {
      console.error("Error creating user:", error);
      toastrError(error.response?.data?.error || "Error creating user, please try again later");
      setIsLoading(false);
    }
  };

  return (
    <dialog id="create-user-modal" className="modal backdrop:bg-[#091E428A]" onCancel={handleESC}>
      <div className="relative col-start-1 row-start-1 max-h-[calc(100vh-5em)] w-11/12 max-w-2xl overflow-y-auto rounded-md bg-white text-ink shadow-overlay">
        <div className="modal-content">
          <button
            type="button"
            aria-label="Sluiten"
            className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded text-ink-subtlest hover:bg-[#091E420F]"
            onClick={handleClose}
          >
            <FeatherIcon icon="x" size={16} />
          </button>
          <h1 className="modal-title px-6 pt-6 text-xl font-medium text-ink">
            Klanten Creëren
          </h1>

          <form className="update-profile-form !mt-0 px-6 py-4" onSubmit={handleSubmit(submitForm)}>
            <div className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
              <div>
                <label htmlFor="naam" className="mb-1 block text-xs font-semibold text-ink-subtlest"> Naam </label>
                <input
                  id="naam"
                  name="naam"
                  type="text"
                  autoComplete="new-password"
                  className={`${errors.naam ? "is-invalid !border-[#AE2A19]" : isSubmitted && "valid"} block w-full appearance-none !rounded !border-2 !border-solid !border-line !bg-white !px-2 !py-1.5 text-sm text-ink focus:!border-brand focus:outline-none`}
                  {...register("naam")}
                />
                <div className="invalid-feedback mt-1 min-h-[16px] text-xs font-normal text-[#AE2A19]">
                  {errors.naam?.message}
                </div>
              </div>

              <div>
                <label htmlFor="email" className="mb-1 block text-xs font-semibold text-ink-subtlest"> Email</label>
                <input
                  id="email"
                  name="email"
                  type="text"
                  autoComplete="new-password"
                  className={`${errors.email ? "is-invalid !border-[#AE2A19]" : isSubmitted && "valid"} block w-full appearance-none !rounded !border-2 !border-solid !border-line !bg-white !px-2 !py-1.5 text-sm text-ink focus:!border-brand focus:outline-none`}
                  {...register("email")}
                />
                <div className="invalid-feedback mt-1 min-h-[16px] text-xs font-normal text-[#AE2A19]">
                  {errors.email?.message}
                </div>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-1 gap-4">
              <div>
                <label htmlFor="telefoonNummer" className="mb-1 block text-xs font-semibold text-ink-subtlest">Telefoon Nummer </label>
                <input
                  id="telefoonNummer"
                  name="telefoonNummer"
                  type="text"
                  autoComplete="new-password"
                  className={`${errors.telefoonNummer ? "is-invalid !border-[#AE2A19]" : isSubmitted && "valid"} block w-full appearance-none !rounded !border-2 !border-solid !border-line !bg-white !px-2 !py-1.5 text-sm text-ink focus:!border-brand focus:outline-none`}
                  {...register("telefoonNummer")}
                />
                <div className="invalid-feedback mt-1 min-h-[16px] text-xs font-normal text-[#AE2A19]">
                  {errors.telefoonNummer?.message}
                </div>
              </div>
            </div>

            <div className="mt-6 flex justify-end gap-2">
              <Button btnClassNames="h-8 rounded bg-brand px-3 text-sm font-medium text-white hover:bg-brand-hover" text="Creëer" isLoading={isLoading} loadingText="Creëren..." />
            </div>
          </form>
        </div>
      </div>
    </dialog>
  );
};

export default CreateUserModal;
